module.exports = __webpack_public_path__ + "img/wallpaper15.61bf635f.png";